import { render, staticRenderFns } from "./tuvzuvlul.vue?vue&type=template&id=66d9cd09&"
import script from "./tuvzuvlul.vue?vue&type=script&lang=js&"
export * from "./tuvzuvlul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports